import { $subscriber } from "fire-wind-water";
import { settings } from "../../common/setting";
import { scmsService } from "../../services/site";
import { URLS } from "fire-wind-water";
const expired = require("../../../art/common/expired.art");

function template(res, timestamp) {
  if (res.result == 0) {
    // 注释： 正式链接用预览链接后，去掉过期时间
    // const time = res.content.time;
    // const difference = 24 * 60 * 60;
    // if (timestamp && (time - timestamp > difference || timestamp > time)) {
    //   document.body.innerHTML = expired();
    //   return;
    // }
    $subscriber.emit("scms-template", { data: res.content });
  }
}

function page(res) {
  if (res.result == 0) {
    $subscriber.emit("scms-page", {
      data: {
        items: res.content?.items || [],
        pageId: settings.pageId,
      },
    });
  }
}

export function preview(): void {
  const tenantId: string = settings.tenantId;
  const siteId: string = settings.siteId;
  const category: string = settings.category;
  const pageId: string = settings.pageId;
  const timestamp: number = settings.t;
  if (tenantId && siteId && category && settings.isPreview) {
    const param: any = {
      tenantId,
      siteId,
      category,
      pageId,
      start: URLS.getURL("start") ? Number(URLS.getURL("start")) : 0,
    };
    // 正式访问的链接改成了预览的链接，正式访问时加参数isSave=1
    const preview = URLS.getURL("preview");
    if (!settings.isDesign && !preview) {
      param.isSave = 1;
    }
    Promise.all([
      scmsService.getList(param),
      scmsService.getPageList({ tenantId, siteId, category }),
    ]).then((res) => {
      page(res[1]);
      template(res[0], timestamp);
    });
  }
}
